import { OperationResult } from '../types/apiTypes';
import { AgeVerificationConfiguration, MobileSecuritySettings, SaveAgeVerificationConfigurationRequest, SaveMobileSecuritySettingsRequest } from '../types/mobileSecuritySettingsTypes';
import api from './api';
import { buildUrlString, SearchParams } from './helpers';

class MobileSecuritySettingsApi {
    static doAuthGetRequest = async <T>(url: string) => await api.doAuthGetRequestAsync<T>(`/MobileSecuritySettings/${url}`);
    static doAuthPostRequestAsync = async <T, R>(url: string, data?: T) =>
        await api.doAuthPostRequestAsync<T, R>('/MobileSecuritySettings/' + url, data);

    static async get(orgId: string) {
        const queryParams: SearchParams = { orgId };
        const url = buildUrlString(queryParams, 'Get');
        return await this.doAuthGetRequest<OperationResult<MobileSecuritySettings>>(url);
    }

    static async save(data: SaveMobileSecuritySettingsRequest) {
        const url = buildUrlString(null, 'Save');
        return await this.doAuthPostRequestAsync<SaveMobileSecuritySettingsRequest, OperationResult<MobileSecuritySettings>>(url, data);
    }

    static async getAgeVerification(orgId: string) {
        const queryParams: SearchParams = { orgId };
        const url = buildUrlString(queryParams, 'GetAgeVerification');
        return await this.doAuthGetRequest<OperationResult<AgeVerificationConfiguration>>(url);
    }

    static async saveAgeVerification(data: SaveAgeVerificationConfigurationRequest) {
        const url = buildUrlString(null, 'SaveAgeVerification');
        return await this.doAuthPostRequestAsync<SaveAgeVerificationConfigurationRequest, OperationResult<AgeVerificationConfiguration>>(url, data);
    }
}

export default MobileSecuritySettingsApi;
